import QRcode from './QRcode';

export default QRcode;